<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click.prevent="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>운송장번호 엑셀 업로드</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="close">닫기</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text class="mt-6 pt-0 pl-6">
          <v-row class="mb-1 col-8 pl-0">
            <v-col class="d-inline-block pl-0 pr-0" cols="7" height="50px">
              <v-file-input
                chips
                label="클릭하여 엑셀 파일을 업로드해주세요."
                class="pt-1 pl-1"
                v-model="excelFile"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              ></v-file-input>
            </v-col>
            <v-col class="d-inline-block pl-0" height="50px">
              <v-btn depressed color="black white--text ml-5" large @click.prevent="readFile">업로드하기</v-btn>
            </v-col>
          </v-row>

          <div>
            <p class="mb-0 body-2 font-weight-light mt-1 black--text">최대 입력 수는 10,000개 입니다.</p>
            <p class="mb-0 body-2 font-weight-light black--text">접수번호와 운송장번호를 입력하여 주세요.</p>
            <p class="mb-0 body-2 font-weight-light black--text">
              ※ 엑셀 파일의 형식은 .xls .xlsx / 파일 용량은 최대 10MB - 큰 용량일 경우 나누어 업로드합니다.
            </p>
          </div>

          <v-btn depressed color="teal" class="mt-3 white--text mb-0" @click.prevent="excelSampleDownLoad">
            엑셀업로드 양식 다운로드
          </v-btn>

          <div class="col-12 pl-0 pb-0" v-if="failSheetData.length > 0">
            <div class="pt-0 pb-0 pl-0 pt-3">
              <strong class="mb-0 body-2 font-weight-blod black--text pt-0 pb-0 mt-0">
                [총
                <font class="font-weight-bold"> {{ sheet.totalCount | numberFormat }} </font>개 -
                <font class="font-weight-bold"> {{ (sheet.totalCount - failSheetData.length) | numberFormat }} </font>개 정상 /
                <font class="font-weight-bold"> {{ failSheetData.length | numberFormat }} </font>개 실패] 업로드한 정보 중 실패된 정보가
                있는 경우 확인하여 재등록해주세요.
              </strong>
            </div>
          </div>

          <v-card class="col-12 col-md-12 mt-2 mb-4 pt-0 pb-0" v-if="failSheetData.length > 0">
            <v-data-table
              :headers="headersAddList"
              :items="failSheetData"
              :items-per-page="20"
              :footer-props="{
                'items-per-page-options': [10, 20, 30, 40, 50],
                'items-per-page-text': '목록 노출 수 선택:',
              }"
            >
              <template slot="no-data">
                <div class="noDataProductInfos">내역이 없습니다.</div>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import M from "@/libs/mapping.js";
import Excel from "@/libs/excel.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import Filters from "@/libs/authservice/filters.js";

export default {
  data() {
    return {
      dialog: false,
      excelFile: null,
      headersAddList: [
        { text: "접수 번호", align: "center", value: "receipt_no", sortable: false, width: 120 },
        { text: "운송장번호", align: "center", value: "tracking_no", sortable: false, width: 160 },
        { text: "실패사유", align: "center", value: "error", sortable: false },
      ],
      sheet: {
        data: [],
        totalCount: 0,
      },
      failSheetData: [],
      sheetHeaderTitle: {
        접수번호: "receipt_no",
        운송장번호: "tracking_no",
      },
    };
  },
  mixins: [CommonMixin],
  filters: Filters,
  methods: {
    open() {
      this.reset();
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    reset() {
      this.excelFile = null;
      this.sheet = { data: [], totalCount: 0 };
      this.failSheetData = [];
    },
    async readFile() {
      if (!this.excelFile) {
        this.alertShow("엑셀파일을 업로드해주세요");
        return;
      }
      if (this.excelFile.size > 10000000) {
        this.alertShow("엑셀파일 사이즈를 10MB 이내로 업로드해주세요.");
        return;
      }
      const ProductExcel = new Excel(this.excelFile, this.sheetHeaderTitle);
      this.sheet.data = await ProductExcel.getNewJson("header");
      this.sheet.totalCount = this.sheet.data.length;
      if (this.sheet.totalCount === 0) {
        this.alertShow("엑셀파일에 업로드할 데이터가 없습니다.");
        return;
      }
      await this.execExcelUpload();
    },
    async execExcelUpload() {
      this.failSheetData = [];
      try {
        await this.waitForShopNo();
        const payload = { items: this.sheet.data };
        const data = await M.api(M.entry("/as/tracking/excel"), payload);
        this.failSheetData = (data && data.fail_list) || [];
        this.alertShow("운송장번호 엑셀 업로드가 완료되었습니다.");
      } catch (e) {
        this.alertShow("운송장번호 엑셀 업로드에 실패했습니다. 잠시 후 다시 시도해주세요.");
      }
    },
    excelSampleDownLoad() {
      const url = "/authservice/etc/sample/운송장번호_엑셀_업로드_양식.xlsx";
      window.open(url);
    },
  },
};
</script>

<style scoped>
.noDataProductInfos {
  padding: 50px 0;
}
</style>
